import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/axelerate-logo-purple.svg'


const _hoisted_1 = { class: "bg-background min-h-screen" }
const _hoisted_2 = { class: "flex flex-col justify-center items-center min-h-screen" }
const _hoisted_3 = { class: "flex flex-col bg-white shadow rounded-2xl w-1/2 xl:w-1/3 p-12" }
const _hoisted_4 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-2/5"
}, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "mt-8"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "text-2xl font-semibold" }, "Complete your account", -1)
const _hoisted_8 = { class: "flex flex-col mt-8" }
const _hoisted_9 = { class: "mb-4" }
const _hoisted_10 = { class: "mb-4" }
const _hoisted_11 = { class: "mb-4" }
const _hoisted_12 = { class: "mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorState = _resolveComponent("ErrorState")!
  const _component_TextField = _resolveComponent("TextField")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.error)
          ? (_openBlock(), _createBlock(_component_ErrorState, { key: 0 }))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _hoisted_5,
              (_ctx.step === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _hoisted_7,
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("form", {
                        onSubmit: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
                      }, [
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_component_TextField, {
                            modelValue: _ctx.first_name,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.first_name) = $event)),
                            name: "first_name",
                            label: "First name",
                            error: _ctx.errors.first_name
                          }, null, 8, ["modelValue", "error"])
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_TextField, {
                            modelValue: _ctx.last_name,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.last_name) = $event)),
                            name: "last_name",
                            label: "Last name",
                            error: _ctx.errors.last_name
                          }, null, 8, ["modelValue", "error"])
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_TextField, {
                            modelValue: _ctx.email,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.email) = $event)),
                            name: "email",
                            label: "Email",
                            error: _ctx.errors.email
                          }, null, 8, ["modelValue", "error"])
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(_component_TextField, {
                            typeInput: "password",
                            modelValue: _ctx.password,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.password) = $event)),
                            name: "password",
                            label: "Password",
                            error: _ctx.errors.password
                          }, null, 8, ["modelValue", "error"])
                        ]),
                        _createElementVNode("button", {
                          type: "submit",
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args))),
                          class: "btn-filled-lg w-full mt-4"
                        }, " Complete Account ")
                      ], 32)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
      ])
    ])
  ]))
}